import { Navigate } from 'react-router-dom';
import useAuth from "../hooks/useAuth";
// import { APICore } from '../helpers/api/apiCore';
import React from 'react';
const Root = () => {
    // const api = new APICore();

    const { auth } = useAuth();
    const username = auth.username ;
    console.log('Root component username:', username);
    const role = auth.main_role;
    const getRootUrl = () => {
        let url: string = 'dashboard';
        if (role=== '3')
        {
            url =`${username}`
        }else if (role === '4') {
            url = 'tickets/bug';
        }
        return url;
    };

    const url = getRootUrl();

    return <Navigate to={`/${url}`} />;
};

export default Root;
